module.exports = __webpack_public_path__ + "img/detail_ja.1682bd83.png";